/**
 * Local storage names used in application
 */
export const LocalStorage = {
  userToken: 'USER_TOKEN',
  image: 'USER_IMAGE',
  opportunityid: 'OPPORTUNITY_ID',
  oppData: 'ALL_OPPORTUNITY',
  url: 'URL',
  url2: 'URL2',
  superOppId: 'SUPER_OPP_ID',
  investmentOppId: 'INVESTMENT_OPP_ID',
  healthOppId: 'HEALTH_OPP_ID',
  generalOppId: 'GENERAL_OPP_ID',
  estateOppId: 'ESTATE_OPP_ID',
  financialOppId: 'FINANCIAL_OPP_ID',
  lifeOppId: 'LIFE_OPP_ID',
  partnerId: 'PARTNER_ID',
  relatedMember: 'RELATED_MEMBER',
  insuranceProvider: 'INSURANCE_PROVIDER',
  decodedToken: 'DECODED_TOKEN',
  illionInstitute: 'ILLION_INSTITUTE',
  creditFileReviewFlag: 'CREDIT_FILE_REVIEW_FLAG',
  occupation: 'OCCUPATION',
  allCountries: 'ALL_COUNTRIES'
};
